import { connect } from 'react-redux';

import { CustomAttributeDefinition } from '../../CAD.types';
import { canEditCAD } from '../../cache/identity.cache';
import {
	sendCustomAttributeDefinitionUpdate,
	getCustomAttributeFormDataAction,
	goToCADListAction,
} from '../../service/CADForm/CADForm.actions';
import { getCADFormLoading, getCADFormData } from '../../service/CADForm/CADForm.selectors';
import {
	CADEdit as Component,
	CADEditDispatchProps,
	CADEditMapProps,
	CADEditProps,
} from './CADEdit.component';

const mapState = (store: any): CADEditMapProps => {
	return {
		hasEntitlement: canEditCAD(),
		loading: getCADFormLoading(store),
		definition: getCADFormData(store),
	};
};

const mapDispatch = (dispatch: Function, ownProps: CADEditProps): CADEditDispatchProps => {
	return {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		fetchCustomAttribute: (id: string) => dispatch(getCustomAttributeFormDataAction(id)),
		onSubmit: (id: string, value: CustomAttributeDefinition) =>
			// eslint-disable-next-line @typescript-eslint/no-unsafe-return
			dispatch(sendCustomAttributeDefinitionUpdate(id, value)),
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		onCancel: () => dispatch(goToCADListAction),
	};
};

const CADEdit = connect(mapState, mapDispatch)(Component);
export { CADEdit };
